import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';
import {Enseignant, StatusEnseignant} from './enseignant.model';
import {DaoGeneric} from '@Services/base/daoService';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EnseignantService extends DaoGeneric<Enseignant> {
  statusEnseignant: Map<StatusEnseignant, string> = new Map<StatusEnseignant, string>([
    [StatusEnseignant.titulaire, 'Titulaire'],
    [StatusEnseignant.vacataire, 'Vacataire'],
  ]);
  readonly url = `${environment.baseUrl}/suaps/enseignant/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(): string {
    return this.url;
  }
  statusEnseignantDisplay(ens: Enseignant) {
    return this.statusEnseignant.get(ens?.status) || '';
  }
  fullName(ens: Enseignant): string {
    return `${ens?.individu_obj?.last_name || ''} ${ens?.individu_obj?.first_name || ''}`;
  }
}
